import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Position } from 'geojson';
import { BuildingFormComponent } from 'src/app/geometrics-form/buildings/building-form/building-form.component';
import { createBuilding } from 'src/app/geometrics-form/buildings/state/building.model';
import { createVertex, Vertex, VertexClass } from 'src/app/geometrics-form/vertexes/state/vertex.model';
import { VertexFormComponent } from 'src/app/geometrics-form/vertexes/vertex-form/vertex-form.component';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { MapDrawService } from '../../shared/components/map/map-draw.service';

@Component({
  selector: 'app-layer-menu',
  templateUrl: './layer-menu.component.html',
  styleUrls: ['./layer-menu.component.scss']
})
export class LayerMenuComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public coordinates: Position,
    private windowService: WindowService,
    private drawService: MapDrawService
  ) { }

  ngOnInit(): void { }

  newBuilding() {
    const featureId = this.drawService.addPoint(this.coordinates[0], this.coordinates[1]);
    const titleConfig = $localize`NEW BUILDING`;
    this.windowService.open({
      title: titleConfig,
      componentType: BuildingFormComponent,
      help: 'CREATE_BUILDINGS',
      config: {
        data: createBuilding({
          longitude: this.coordinates[0],
          latitude: this.coordinates[1]
        })
      }
    })
      .subscribe(() => this.drawService.delete(featureId));
  }

  newVertex(vertexClass: string) {
    const featureId = this.drawService.addPoint(this.coordinates[0], this.coordinates[1]);
    const vertex: Vertex = createVertex({
      vertex_class: vertexClass as VertexClass,
      longitude: this.coordinates[0],
      latitude: this.coordinates[1]
    });
    const titleConfig = $localize`NEW VERTEX`;
    this.windowService.open({
      title: titleConfig,
      componentType: VertexFormComponent,
      help: 'CREATE_VERTEX',
      config: { data: vertex }
    }).subscribe(() => this.drawService.delete(featureId));
  }

}

